import { logEvent } from "firebase/analytics";
import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import { useNavigation } from "react-navi";

import { analytics } from "../firebase";
import RedirectLayout from "./redirect";

export default function AuthenticatedLayout({ children }) {
  const check = useCallback((context) => {
    return !context.user;
  }, []);

  const navigation = useNavigation();

  useEffect(() => {
    if (!navigation) {
      return;
    }

    let lastHref = "";

    const subscription = navigation.subscribe((route) => {
      if (lastHref === route.url.href) {
        return;
      }
      lastHref = route.url.href;
      logEvent(analytics, "page_view", {
        title: route.title,
        url: route.url.href,
      });
    });

    return () => subscription.unsubscribe();
  }, [navigation]);

  let redirect = `?redirect=${encodeURIComponent(
    window.location.pathname + window.location.search
  )}`;

  return (
    <RedirectLayout condition={check} redirectUrl={"/login/" + redirect}>
      {children}
    </RedirectLayout>
  );
}

AuthenticatedLayout.propTypes = {
  children: PropTypes.node,
};
